import axios from 'axios';

export function getTeachers() {
  return axios.get('/api/teachers');
}

export function getTeacherTemplates(id) {
  return axios.get(`/api/teachers/${id}/classroom-templates`);
}

export function getTeacherTiers(slug) {
  return axios.get(`/api/teachers/${slug}/tiers`);
}

export function getTeacherMedia(id) {
  return axios.get(`/api/teachers/${id}/media`);
}

export function getTeacherTemplate(teacherId, templateId) {
  return axios.get(`/api/teachers/${teacherId}/classroom-templates/${templateId}`);
}

export function getTeacherClassrooms(id) {
  return axios.get(`/api/teachers/${id}/classrooms`);
}

export function getClassroom(slug) {
  return axios.get(`/api/classrooms/${slug}`);
}

export function getTeacherById(id) {
  return axios.get(`/api/teachers/${id}`);
}

export function getTeacherBySlug(slug) {
  return axios.get(`/api/teachers/user/${slug}`);
}

export function updateTeacherData(id, data) {
  return axios.put(`/api/teachers/${id}`, data);
}

export function getTeacherMasterclasses(slug) {
  return axios.get(`/api/teachers/${slug}/masterclasses`);
}

export function getTeacherFreeSlots(id, startDate) {
  return axios.get(`/api/teachers/${id}/free?startDate=${startDate}`);
}

export function getTeacherLockedSlots(id) {
  return axios.get(`/api/teachers/${id}/locked`);
}

export function getAllTeacherSlots(id) {
  return axios.get(`/api/teachers/${id}/private`);
}

export function getTeacherWorkshops(id) {
  return axios.get(`/api/teachers/${id}/workshops`);
}

export function getTeacherReviews(slug) {
  return axios.get(`/api/teachers/${slug}/reviews`);
}

export function getTeacherExperiences(id) {
  return axios.get(`/api/teachers/${id}/work-experiences`);
}

export function getTeacherInstruments(id) {
  return axios.get(`/api/teachers/${id}/instruments`);
}

export function getTeacherLessonPayments(id) {
  return axios.get(`/api/teachers/${id}/lesson-payments`);
}

export function getTeacherReceivedPayments(id) {
  return axios.get(`/api/teachers/${id}/received-payments`);
}
